import styled from "@emotion/styled";
import { ThemeStyle } from "assets/scss/common/theme";


export const WalletBSWrapper = styled.div`
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.5px;
  .bs-content {
    height: auto;
  }

  .bs-body {
    &:after {
      content: "";
      padding-top: 82px;
      display: block;
    }
  }
`;

export const VerifyOtpButton = styled.div`
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
`;

export const VerifyOtpInput = styled.div`
  .otpContainer {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }

  .otpInput {
    position: relative;
    width: 44px !important;
    height: 56px;
    margin: 0.1rem;
    margin-top: 10px;
    text-align: center;
    border-radius: ${({ theme }: ThemeStyle) => theme.borders.radiusPrimary};
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
    background: ${({ theme }: ThemeStyle) => theme.grey.G1};
    &:focus {
      border-bottom: 1px solid ${({ theme }: ThemeStyle) => theme.brandPrimary};
    }
    ::placeholder {
      position: absolute;
      width: 12px;
      height: 12px;
      left: 36px;
      top: 510px;

      background: rgba(0, 19, 37, 0.16);
      mix-blend-mode: normal;
      opacity: 0.36;
      border: 1.5px solid #001325;
      box-sizing: border-box;
    }
  }
`;

interface FlexDivProps {
  disabled: boolean;
}

export const FlexDiv = styled.div<ThemeStyle>`
  display: flex;
  color: ${({ theme }: ThemeStyle) => theme.brandPrimary};
  &.disabled {
    pointer-events: none;
    color: black;
  }
`;

export const OverlayWrapLayout = styled.div`
  display: flex;
  box-sizing: border-box;
  background-color: ${({ theme }: ThemeStyle) => theme?.colors?.snow100};
  border-radius: 8px;
  padding: 36px 36px 16px 36px;
  flex-direction: column;
  position: relative;
  width: 392px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 300px;
  p:first-of-type {
    margin-bottom: 8px;
  }
`;

export const IconWrapLayout = styled.div`
  position: absolute;
  top: 14px;
  left: 14px;
`;
